import { render, staticRenderFns } from "./PayerActivation.vue?vue&type=template&id=0469fecc&scoped=true"
import script from "./PayerActivation.vue?vue&type=script&lang=js"
export * from "./PayerActivation.vue?vue&type=script&lang=js"
import style0 from "./PayerActivation.vue?vue&type=style&index=0&id=0469fecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0469fecc",
  null
  
)

export default component.exports